import React from 'react'

export default function CourseSection(props) {
  return (
    <>
    <span class = "">{props.section}</span>
    </>
  )
}
